export default "__VITE_PUBLIC_ASSET__88cfe394__"